module.exports = __webpack_public_path__ + "static/media/349.4b59776f.png";